<div class="basic-container" *ngIf="mode == 'tree'">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree-container">
        <mat-tree-node *matTreeNodeDef="let node"
                       matTreeNodeToggle
                       matTreeNodePadding>
            <button mat-icon-button disabled></button>
            <mat-card class="process-card">
                <mat-card-header>
                    <mat-card-title><mat-icon mat-card-avatar>{{node.icon}}</mat-icon> {{node.name}}</mat-card-title>
<!--                    <mat-card-subtitle>{{node|json}}</mat-card-subtitle>-->
                    <mat-card-subtitle>{{node.processType ? node.processType.name : ''}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <p>{{node.description}}</p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="warn" *ngIf="node.level > 0" (click)="deleteStep(node)">Delete</button>
                    <div fxFlex></div>
                    <button mat-button mat-raised-button color="alt" *ngIf="node.level == 0" (click)="transformStep(node)"><mat-icon>library_books</mat-icon> Form</button>
                    <button mat-button mat-raised-button color="alt" *ngIf="node.level > 0 && node.processType && node.processType.code == 'HANDLEBARS'" (click)="transformStep(node)"><mat-icon>tune</mat-icon> Template</button>
                    <button mat-button mat-raised-button color="alt" *ngIf="node.level > 0 && node.processType && node.processType.code == 'HTML2PDF'" (click)="transformStep(node)"><mat-icon>picture_as_pdf</mat-icon> View</button>
                    <button mat-button mat-raised-button color="accent" *ngIf="node.level > 0" (click)="editStep(node)">Edit</button>
                    <button mat-button mat-raised-button color="primary" (click)="addStep(node)">Add</button>
                </mat-card-actions>
            </mat-card>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
                       matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.filename">
                <mat-icon class="mat-icon-rtl-mirror tree-icon">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>

            <mat-card class="process-card">
<!--                      [ngClass]="{'drop-above': dragNodeExpandOverArea === 'above' && dragNodeExpandOverNode === node,-->
<!--                              ' drop-below': dragNodeExpandOverArea === 'below' && dragNodeExpandOverNode === node,-->
<!--                              'drop-center': dragNodeExpandOverArea === 'center' && dragNodeExpandOverNode === node}"-->
<!--                      draggable="true"-->
<!--                      (dragstart)="handleDragStart($event, node);"-->
<!--                      (dragover)="handleDragOver($event, node);"-->
<!--                      (drop)="handleDrop($event, node);"-->
<!--                      (dragend)="handleDragEnd($event);"-->
<!--                      (change)="todoItemSelectionToggle(node)"-->
                <mat-card-header>
                    <mat-card-title><mat-icon mat-card-avatar>{{node.icon}}</mat-icon> {{node.name}}</mat-card-title>
                    <mat-card-subtitle>{{node.processType.name}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <p>{{node.description}}</p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="warn" *ngIf="node.level > 0" (click)="deleteStep(node)">Delete</button>
                    <div fxFlex></div>
                    <button mat-button mat-raised-button color="alt" *ngIf="node.level == 0" (click)="transformStep(node)"><mat-icon>library_books</mat-icon> Form</button>
                    <button mat-button mat-raised-button color="alt" *ngIf="node.level > 0 && node.processType && node.processType.code == 'HANDLEBARS'" (click)="transformStep(node)"><mat-icon>tune</mat-icon> Template</button>
                    <button mat-button mat-raised-button color="alt" *ngIf="node.level > 0 && node.processType && node.processType.code == 'HTML2PDF'" (click)="transformStep(node)"><mat-icon>picture_as_pdf</mat-icon> View</button>
                    <button mat-button mat-raised-button color="accent" *ngIf="node.level > 0" (click)="editStep(node)">Edit</button>
                    <button mat-button mat-raised-button color="primary" (click)="addStep(node)">Add</button>
                </mat-card-actions>
            </mat-card>
        </mat-tree-node>
    </mat-tree>
</div>

<span #emptyItem></span>


<!--<pre>-->
<!--    {{dataSource.data|json}}-->
<!--</pre>-->

<div *ngIf="mode == 'FORM_OUTPUT'">
    <sprout-designer-form-output [processNode]="transformationNode" (formModelChangeEvent)="onFormChange($event)"></sprout-designer-form-output>
</div>

<div *ngIf="mode == 'HANDLEBARS'">
    <sprout-designer-handlebars [processNode]="transformationNode" (templateChangeEvent)="onTemplateChange($event)" (formModelChangeEvent)="onFormChange($event)"></sprout-designer-handlebars>
</div>

<div *ngIf="mode == 'JOLT'">
    <sprout-designer-jolt [processNode]="transformationNode"></sprout-designer-jolt>
</div>

<div *ngIf="mode == 'TRANSLATIONS'">
    <sprout-designer-translation [processNode]="transformationNode"></sprout-designer-translation>
</div>

<div *ngIf="mode == 'HTML2PDF'">
    <sprout-designer-html2pdf [processNode]="transformationNode"></sprout-designer-html2pdf>
</div>

